import React, { useCallback } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

import { Link } from '@mui/material';

import WarningNoticeBanner from '../../../../components/designe/warning-notice-banner/WarningNoticeBanner';
import { useRegisterPageContainerError } from '../../../../components/layout/page-container/page-container-error-handler';
import { useGetUserTrainingAccessOutgoing } from '../../../../redux/api/userTrainingAccessApi';
import { Paths } from '../../../../shared/paths';
import TrainingList from '../training-list/TrainingList';
import { useAvailableTrainingsPage } from './useAvailableTrainingsPage';

const AvailableTrainings = () => {
  const { t } = useTranslation();
  const { trainings, isLoading, filter, setFilter, error, refetch } =
    useAvailableTrainingsPage();
  const {
    data: accessData,
    isLoading: isAccessLoading,
    isFetching: isAccessFetching,
  } = useGetUserTrainingAccessOutgoing();
  const isDataLoading = isLoading || isAccessLoading || isAccessFetching;
  const showAccessWarning =
    !isDataLoading &&
    trainings !== null &&
    trainings.length === 0 &&
    (accessData?.shareTrainings?.length ?? 0) === 0;
  const handleRetry = useCallback(() => {
    void refetch();
  }, [refetch]);
  useRegisterPageContainerError({
    errors: error ? [error] : [],
    isLoading: isDataLoading,
    hasData: Boolean(trainings?.length),
    onRetry: handleRetry,
  });

  return (
    <TrainingList
      listKind="available"
      trainings={trainings}
      searchValue={filter}
      onSearchChange={setFilter}
      isLoading={isDataLoading}
      showAvatar={true}
      sharedNavigation
      emptyStateBanner={
        showAccessWarning ? (
          <WarningNoticeBanner title={t('trainings.availableEmptyBannerTitle')}>
            <Trans
              i18nKey="trainings.availableEmptyBannerDescription"
              components={[
                <Link
                  key="access-link"
                  component={RouterLink}
                  to={Paths.settings.toAccess}
                />,
              ]}
            />
          </WarningNoticeBanner>
        ) : null
      }
    />
  );
};

export default AvailableTrainings;
